import React from "react";
import { SvgIcon } from "@material-ui/core";

const EFactura = props => (
  <SvgIcon viewBox="0 0 13.571 16.867" {...props}>
    <g
      id="Grupo_1212"
      data-name="Grupo 1212"
      transform="translate(-305.366 -236.39)"
    >
      <g
        id="Grupo_811"
        data-name="Grupo 811"
        transform="translate(305.366 236.39)"
      >
        <g id="Grupo_805" data-name="Grupo 805">
          <g
            id="Grupo_78"
            data-name="Grupo 78"
            transform="translate(3.346 3.991)"
          >
            <path
              id="Trazado_754"
              data-name="Trazado 754"
              d="M318.187,250.814a4.847,4.847,0,0,0-1.532-.73v1.855c1.9.524,2.662,1.25,2.662,2.621v.038c0,1.371-1.048,2.258-2.621,2.419v1.21H315.4v-1.245a6.156,6.156,0,0,1-2.9-1.168l.973-1.412a5.012,5.012,0,0,0,2.016,1.008v-1.936c-1.774-.486-2.662-1.129-2.662-2.621v-.04c0-1.372,1.048-2.258,2.582-2.42v-.73h1.33v.766a5.487,5.487,0,0,1,2.3.888Zm-2.7.851v-1.7c-.608.081-.851.365-.851.766v.04c.005.4.207.646.851.888Zm1.17,2.138v1.734c.564-.081.888-.365.888-.806v-.04c0-.408-.2-.65-.888-.892Z"
              transform="translate(-312.501 -247.664)"
              fill="rgba(112,112,112,0.35)"
            />
          </g>
          <path
            id="Trazado_755"
            data-name="Trazado 755"
            d="M317.3,236.39h-10.33a1.527,1.527,0,0,0-1.6,1.437v13.982a1.524,1.524,0,0,0,1.59,1.448h10.379a1.527,1.527,0,0,0,1.6-1.437V237.838A1.582,1.582,0,0,0,317.3,236.39Zm.322,15.387a.308.308,0,0,1-.322.291h-10.33a.308.308,0,0,1-.322-.291h0V240.124a.308.308,0,0,1,.322-.291h10.366a.308.308,0,0,1,.322.291h0v11.653Z"
            transform="translate(-305.366 -236.39)"
            fill="rgba(112,112,112,0.35)"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default EFactura;
